import { jsx as _jsx } from "react/jsx-runtime";
export const SvgCheck = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'm6 13 4 4 8.5-10' }) }));
//# sourceMappingURL=check.js.map